// Async client-import job. Synced to the dashboard via `npm run dto:sync` so the
// upload-and-poll UI can render progress. See docs/epics/tenant-client-import.md §13.

export enum ImportJobStatus {
  // Two-phase preview: the upload parses server-side and lands here with
  // canonical counts. Nothing is created until the operator confirms.
  READY = 'ready',
  // Confirmed by the operator and queued; the cron claims PENDING jobs.
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  PARTIAL = 'partial',
  FAILED = 'failed',
  ROLLED_BACK = 'rolled_back',
  // Operator discarded a READY job before it ran (raw content reclaimed).
  CANCELED = 'canceled',
}

export interface ImportJobRowError {
  row: number;
  email: string;
  reason: string;
}

export interface ImportJobDto {
  id: string;
  organizationId: string;
  status: ImportJobStatus;
  fileName: string;
  totalRows: number;
  processedRows: number;
  successCount: number;
  skippedCount: number;
  errorCount: number;
  // Live count of this run's imported clients who have since signed in (claimed).
  // Claim rate = claimedCount / successCount. Only set by the history list.
  claimedCount?: number;
  // Capped sample of per-row failures (first N), for the results panel.
  errors: ImportJobRowError[];
  fatalError?: string | null;
  cohort?: { id?: string; name?: string };
  createdAt: string;
  startedAt?: string | null;
  completedAt?: string | null;
}
